import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { login } from '../../redux/slices/authSlice';
import { GetUser } from '../../Services';

function Login() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({ email: "", password: "" });
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false)

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const validate = () => {
        let newErrors = {};

        if (!formData.email) {
            newErrors.email = "Username or email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && !/^[a-zA-Z0-9_]+$/.test(formData.email)) {
            newErrors.userIdentifier = "Enter a valid email or username";
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validate()) return;
    
        setLoading(true)

        GetUser.getUserLogin(formData.email, formData.password).then(async (response) => {
            if (response.data) {
                const userResponse = response.data
                const userData = {
                    user: {
                        id: userResponse.admin.id,
                        name: userResponse.admin.name,
                        email: userResponse.admin.email,
                        role: userResponse.admin.role,
                        // profileImage: userResponse.user.owner_profile.profileImage,
                        // profileId: userResponse.user.owner_profile.id
                    },
                    token: userResponse.token,
                    // refresh: userResponse.refresh
                };
                toast.success('Authentication Successfull')
                await dispatch(login(userData)); // Ensure login completes
                setLoading(false)
                navigate('/');
            }
        }).catch((error) => {
            console.error(error)
            setLoading(false)
            toast.error('Authentication Failed')
        })
    };

    return (
        <div className="hold-transition login-page">
            <div className="login-box">
                <div className="card card-outline card-primary">
                    <div className="card-header text-center">
                        <a href="../../index2.html" className="h1"><b>Admin</b>LTE</a>
                    </div>
                    <div className="card-body">
                        <p className="login-box-msg">Sign in to start your session</p>
                        <form onSubmit={handleLogin}>
                            <div className="input-group mb-3">
                                <input type="email" name='email' className="form-control" value={formData.email} placeholder="Email" onChange={(e) => handleChange(e)} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                                {errors.email && <p className="text-danger fs-5">{errors.email}</p>}
                            </div>
                            <div className="input-group mb-3">
                                <input type="password" name='password' className="form-control" value={formData.password} placeholder="Password" onChange={(e) => handleChange(e)} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                                {errors.password && <p className="text-danger fs-5">{errors.password}</p>}
                            </div>

                            <div className="row">
                                <div className="col-8">
                                    {/* <div className="icheck-primary">
                                        <input type="checkbox" id="remember" />
                                        <label for="remember">
                                            Remember Me
                                        </label>
                                    </div> */}
                                </div>
                                <div className="col-4">
                                    <button type="submit" className="btn btn-primary btn-block">{loading ? "Loading..." : "Sign In"}</button>
                                </div>
                            </div>
                        </form>
                        <p className="mb-1">
                            <a href="forgot-password.html">I forgot my password</a>
                        </p>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login